import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { MissionsService } from 'src/app/services/missions.service';
import { AlertController } from '@ionic/angular';
import { ToolsService } from 'src/app/services/tools.service';
import { AuthService } from 'src/app/services/auth.service';
import { ConfigService } from 'src/app/services/config.service';
import { ModalAdditionalQuestionsPage } from '../modal-additional-questions/modal-additional-questions.page';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ModalIaResultsResumePage } from '../modal-ia-results-resume/modal-ia-results-resume.page';
export class ModalIaModulePage {
    constructor(modalController, missionsService, navParams, alertController, toolsService, authService, analyticsService, configService) {
        this.modalController = modalController;
        this.missionsService = missionsService;
        this.alertController = alertController;
        this.toolsService = toolsService;
        this.authService = authService;
        this.analyticsService = analyticsService;
        this.configService = configService;
        // Variables
        this.steps = 0; //
        this.ia_activities = []; // array of activities
        this.base64String = ''; // base64 string
        this.processingStep = 0; // current processing step
        this.isProcessing = false; // flag to indicate if processing is in progress
        this.resultReady = false; // flag to indicate if result is ready
        this.progressValue = 0; // progress value for loading animation
        this.selectedActivities = []; // array to store selected activities
        this.ia_result = []; // result of IA activity
        this.seeFile = false;
        this.isLoading = true; // flag to indicate if loading is in progress
        this.showDelayMessage = false; // flag to show delay message
        // Show 1 slide at a time, with pagination enabled, also show arrows and autoplay
        this.sliderOptions = { slidesPerView: 1, pagination: { clickable: true }, navigation: true, autoplay: true, loop: true };
        this.loadingMessage = '0';
        this.progressPercent = 0;
        this.totalSteps = 0;
        this.currentStep = 0;
        this.uploadFiles = []; // Array to store uploaded files when allowing multiple files
        this.seeResults = false;
        this.reasons = [];
        this.markAllActivities = false;
        this.activeReason = null;
        this.showLegend = true;
        this.selectedActivity = null;
        this.show_rules_invalid = false;
        this.template = navParams.get('template');
        this.seeFile = navParams.get('seeFiles');
        this.playerData = navParams.get('playerData');
        this.ia_activities = this.template.ia_activity;
        this.uploadCountKey = `ia_upload_count_${this.template.id}`;
        this.getReferralsInfo();
    }
    ngOnInit() {
        this.ia_activities = this.ia_activities.map(activity => {
            const isChecked = this.ia_activities.length === 1 ? true : false;
            const updatedActivity = Object.assign({}, activity, { checked: isChecked });
            if (isChecked) {
                this.selectedActivities.push(updatedActivity);
                this.markAllActivities = true;
            }
            return updatedActivity;
        });
        this.analyticsService.AnalyticsServiceModalView('IA Modal - ' + this.template.name);
        this.ia_result.forEach(r => r.showReason = false);
        const count = Number(localStorage.getItem(this.uploadCountKey) || '0');
        if (count >= this.template.settings[0].max_show_instructions) {
            this.steps = 1;
        }
        if (this.seeFile) {
            this.isLoading = true;
            this.missionsService.get_results().then((response) => {
                this.resultIa = response;
                // console.log("ResultIA ", this.resultIa);
                this.isLoading = false;
            }).catch(error => {
                this.isLoading = false;
            });
        }
    }
    onFileSelected(event) {
        const file = event.target.files[0];
        this.originalFile = file;
        if (file) {
            if (file.type.startsWith("image/") || file.type == "application/pdf") {
                const reader = new FileReader();
                reader.onload = () => {
                    this.fileType = file.type.startsWith("image/") ? 'image' : 'pdf';
                    this.base64String = reader.result;
                    this.processImage();
                };
                reader.onerror = (error) => {
                    console.error('Error reading file:', error);
                };
                reader.readAsDataURL(file);
            }
            else {
                console.error("Invalid file type. Please select an image or PDF.");
            }
        }
    }
    reset() {
        this.steps = 0;
        this.processingStep = 0;
        this.isProcessing = false;
        this.resultReady = false;
    }
    //Function to process image (Loading)
    processImage() {
        this.selectedActivitiesCheckpoint = this.selectedActivities;
        this.incrementUploadCount();
        this.steps = 2;
        this.isProcessing = true;
        this.processingStep = 1;
        this.progressValue = 0.2;
        this.showDelayMessage = false;
        this.totalSteps = this.ia_activities.length + 3;
        this.currentStep = 0;
        this.updateProgress('Iniciando proceso...', 10);
        const startTime = Date.now();
        const progressInterval = setInterval(() => {
            if (this.progressValue < 0.8) {
                this.progressValue += 0.005;
            }
        }, 200);
        const delayTimeout = setTimeout(() => {
            this.showDelayMessage = true;
        }, 40000);
        let response = this.missionsService.generateToken(this.template.id).then((response) => {
            const elapsed = Date.now() - startTime;
            this.currentStep++;
            this.token = response;
            this.updateProgress('Subiendo archivo...', 30);
            if (this.token.token == null) {
                this.toolsService.showErrorToast('Error en el procesamiento de IA, intentalo de nuevo mas tarde');
                this.steps = 1;
                this.isProcessing = false;
                clearTimeout(delayTimeout);
                clearInterval(progressInterval);
                return;
            }
            clearInterval(progressInterval);
            this.progressValue = 0.7;
            this.processingStep = 3;
            this.iaProcess().then(() => {
                setTimeout(() => {
                    if (this.ia_result.some(result => result.result.final_state === 'REJECTED')) {
                        this.steps = 3;
                    }
                    this.progressValue = 1;
                    this.currentStep = this.totalSteps;
                    this.updateProgress(null, 49);
                    this.isProcessing = false;
                    this.resultReady = true;
                    clearTimeout(delayTimeout);
                }, 1000);
            });
        }, error => {
            clearTimeout(delayTimeout);
            clearInterval(progressInterval);
            this.isProcessing = false;
            this.steps = 1;
        });
    }
    // Function to handle activity selection 
    onActivitySelect(id, state) {
        const index = this.selectedActivities.findIndex(activity => activity.id === id);
        if (index === -1) {
            this.selectedActivities.push({ id, state });
            this.validateRules();
        }
        else {
            this.selectedActivities.splice(index, 1);
        }
    }
    isSelected(id) {
        return this.selectedActivities.some(activity => activity.id === id);
    }
    setDefaultSelections() {
        this.selectedActivities = this.ia_result
            .filter(res => res.result.final_state !== 'REJECTED')
            .map(res => ({ id: res.activity.id, state: res.result.final_state }));
    }
    validatedocumentDuratex() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const alert = yield this.alertController.create({
                header: 'Validar documento',
                message: 'Por favor ingresa el documento del carpintero:',
                inputs: [
                    {
                        name: 'cedula',
                        type: 'text',
                        placeholder: 'Documento'
                    }
                ],
                buttons: [
                    {
                        text: 'Cancelar',
                        role: 'cancel'
                    },
                    {
                        text: 'Continuar',
                        handler: (data) => {
                            const cedula = data.cedula;
                            if (!cedula) {
                                this.alertController.create({
                                    header: 'Error',
                                    message: 'Debe ingresar una cédula válida.',
                                    buttons: ['OK']
                                }).then(errorAlert => errorAlert.present());
                                return false;
                            }
                            this.toolsService.showLoader('Validando documento...');
                            this.missionsService.validatedocumentDuratex(cedula).then((response) => {
                                this.toolsService.dismissLoader();
                                if (response.is_carpenter === true) {
                                    this.alertController.create({
                                        header: 'Documento válido',
                                        message: 'El documento pertenece a un carpintero registrado.',
                                        buttons: ['OK']
                                    }).then(successAlert => successAlert.present());
                                }
                                else {
                                    this.alertController.create({
                                        header: 'Carpintero no registrado',
                                        message: '👉 Invítalo a inscribirse en el siguiente enlace para que puedas subir facturas y ganar ' + this.configService.company_info.points_name + '.<br><br>📲 ' + this.configService.company_info.variants[0].domain + '/autenticacion?referral=' + this.referrals_info.referral_code,
                                        buttons: [
                                            {
                                                text: 'Copiar enlace',
                                                handler: () => {
                                                    try {
                                                        chrome.windows.create({ "url": this.configService.company_info.variants[0].domain + '/autenticacion?referral=' + this.referrals_info.referral_code, "incognito": true });
                                                    }
                                                    catch (error) {
                                                        console.debug('Error opening link in incognito mode:', error);
                                                    }
                                                    // window.open('https://club.duratex.com.co', '_blank');
                                                    navigator.clipboard.writeText(this.configService.company_info.variants[0].domain + '/autenticacion?referral=' + this.referrals_info.referral_code);
                                                    this.toolsService.showSuccessToast('Enlace copiado al portapapeles.');
                                                    return false;
                                                }
                                            },
                                            'OK'
                                        ]
                                    }).then(errorAlert => errorAlert.present());
                                }
                            }).catch(() => {
                                this.toolsService.dismissLoader();
                                this.alertController.create({
                                    header: 'Error',
                                    message: 'Ocurrió un error al validar el documento.',
                                    buttons: ['OK']
                                }).then(errorAlert => errorAlert.present());
                            });
                            return true;
                        }
                    }
                ]
            });
            yield alert.present();
        });
    }
    validateRules() {
        for (let i = 0; i < this.selectedActivities.length; i++) {
            const activityId = this.selectedActivities[i];
            const activity = this.ia_activities.find((activity) => activity.id === activityId);
        }
    }
    //Function to 
    iaProcess() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.isLoading = true;
            this.loadingMessage = 'Subiendo archivo...';
            try {
                if (this.base64String.startsWith("data:image/"))
                    this.pk = yield this.missionsService.externalprocess(this.token.token, this.base64String);
                else
                    this.pk = yield this.missionsService.externalprocess(this.token.token, null, this.base64String);
                const data = this.pk;
                this.pk = this.pk.pk;
                yield this.missionsService.saveFile(data.upload.url, this.originalFile, data.upload.headers['Content-Type']);
            }
            catch (error) {
                console.error('Error during external process:', error);
                this.analyticsService.AnalyticsServiceError('ia-upload', error.message);
                return this.manageIaError(1);
            }
            this.currentStep++;
            this.updateProgress('Leyendo información del archivo...', 49);
            const waitStart = Date.now();
            const waitInterval = setInterval(() => {
                const seconds = (Date.now() - waitStart) / 1000;
                if (seconds > 14) {
                    this.loadingMessage = 'Estamos tardando más de lo normal...';
                }
                else if (seconds > 8) {
                    this.loadingMessage = 'Estamos validando tu archivo...';
                }
            }, 1000);
            try {
                yield this.missionsService.waitForResponse(this.token.token, this.pk);
            }
            catch (error) {
                clearInterval(waitInterval);
                this.analyticsService.AnalyticsServiceError('ia-wait-response', error.message);
                return this.manageIaError(2);
            }
            clearInterval(waitInterval);
            this.currentStep++;
            let results = [];
            let index = 0;
            this.updateProgress(null, 95);
            // for (let activity of this.ia_activities) {
            for (let activity of this.selectedActivities) {
                index++;
                // Show loading message for each activity if there are more than one
                if (this.selectedActivities.length > 1)
                    this.loadingMessage = `Comprobando reglas de las actividades (${index}/${this.selectedActivities.length})`;
                else
                    this.loadingMessage = 'Comprobando reglas de la actividad';
                this.progressPercent = Math.round(((this.currentStep + index - 1) / this.totalSteps) * 100);
                let response;
                try {
                    response = yield this.missionsService.resultIaActivity(activity.id, this.pk);
                }
                catch (error) {
                    console.error('Error getting IA result for activity', activity.id, error);
                    this.analyticsService.AnalyticsServiceError('ia-get-result', error.message);
                    return this.manageIaError(3);
                }
                results.push({
                    activity: activity,
                    result: response
                });
            }
            this.currentStep += this.selectedActivities.length;
            this.updateProgress();
            console.debug('Results from IA:', results);
            this.ia_result = results;
            this.setDefaultSelections();
            this.validateRules();
            const notRejected = results.every(result => result.result.final_state === 'APPROVED' || result.result.final_state === 'MANUAL_VALIDATION');
            if (notRejected) {
                this.showResult(this.ia_result);
            }
        });
    }
    manageIaError(errorCode, errorMessage) {
        this.steps = 0;
        this.isLoading = false;
        this.closeModal();
        if (!errorMessage || errorMessage == '')
            errorMessage = 'Error al validar el archivo, por favor, inténtalo nuevamente. Si el error persiste, contacta a soporte.';
        this.toolsService.showErrorToast(`[${errorCode}] ` + errorMessage);
    }
    save() {
        console.log("activities", this.selectedActivities);
        this.steps = 4;
        this.isLoading = true;
        const savePromises = this.selectedActivities.map(activityId => {
            if (activityId.additional_answers && Array.isArray(activityId.additional_answers)) {
                activityId.additional_answers.map(answer => {
                    if (answer) {
                        return this.missionsService.saveResponse(activityId.id, this.base64String, this.pk, activityId.state, answer.answers_to_save);
                    }
                });
            }
            else {
                return this.missionsService.saveResponse(activityId.id, this.base64String, this.pk, activityId.state);
            }
        });
        Promise.all(savePromises)
            .then(() => {
            this.isLoading = false;
        })
            .catch(error => {
            this.steps = 1;
        });
    }
    //Function to close modal
    closeModal() {
        this.modalController.dismiss();
    }
    goBack() {
        this.uploadFiles = [];
        this.steps = 1;
        this.ia_result = [];
        this.selectedActivities = this.selectedActivitiesCheckpoint;
    }
    goFirstStep() {
        this.steps = 1;
        // this.selectedActivities = [];
        this.ia_result = [];
        this.base64String = '';
    }
    openReason(result) {
        this.activeReason = result;
    }
    closeReason() {
        this.activeReason = null;
    }
    updateProgressPercentage(maxValue) {
        const currentTimer = setInterval(() => {
            if (this.progressPercent < maxValue) {
                // Increment the progress percentage in random intervals
                this.progressPercent += Math.floor(Math.random() * 2) + 0; // Increment by 0 to 2
            }
            else {
                clearInterval(currentTimer);
            }
        }, 600);
    }
    updateProgress(message, maxValue) {
        if (message !== undefined) {
            this.loadingMessage = message;
        }
        if (this.totalSteps > 0) {
            this.progressPercent = Math.round((this.currentStep / this.totalSteps) * 100);
        }
        else {
            this.progressPercent = 0;
        }
        if (maxValue)
            this.updateProgressPercentage(maxValue);
    }
    incrementUploadCount() {
        const current = Number(localStorage.getItem(this.uploadCountKey) || '0');
        localStorage.setItem(this.uploadCountKey, String(current + 1));
    }
    getStateLabel(state) {
        switch (state) {
            case 'APPROVED':
                return 'APROBADO';
            case 'REJECTED':
                return 'NO APROBADO';
            case 'MANUAL_VALIDATION':
                return 'EN VALIDACIÓN';
            default:
                return state;
        }
    }
    get hasNonRejectedActivities() {
        return this.ia_result.some(result => result.result.final_state === 'APPROVED' ||
            result.result.final_state === 'MANUAL_VALIDATION');
    }
    /** When allowing multiple files, this function will handle the file selection
     * Function to handle file selection
     * @param event
     */
    onFilesSelected(event) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const files = event.target.files;
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                const base64 = yield this.convertToBase64(file);
                const newFile = {
                    id: Math.floor(Math.random() * 100000),
                    name: file.name,
                    file: base64,
                    loading: true,
                    state: 'pending',
                    reject_reasons: null,
                    fileType: file.type.startsWith("image/") ? 'image' : 'pdf',
                    pk: null
                };
                if (this.selectedActivities.length > 1) {
                    this.uploadFiles.push(newFile);
                    console.log("New file added:", this.uploadFiles);
                    this.uploadProcess(newFile, file);
                }
                else if (this.selectedActivities.length === 1) { // 1 activity, so we can process the file immediately
                    this.uploadFiles.push(newFile);
                    console.log("New file added:", this.uploadFiles, file);
                    this.uploadProcess(newFile, file);
                }
            }
        });
    }
    /**
     * Convert a file to base64 string.
     * @param file
     */
    convertToBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file); // base64 con prefijo tipo: data:image/png;base64,...
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }
    /**
     * Generate token
     */
    generateToken() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                console.log("template id", this.template.id);
                const response = yield this.missionsService.generateToken(this.template.id);
                if (response.token) {
                    return response;
                }
                else {
                    throw new Error('Token no válido');
                }
            }
            catch (error) {
                console.error('Error generating token:', error);
                throw error;
            }
        });
    }
    waitSeconds(seconds) {
        return new Promise(resolve => setTimeout(resolve, seconds * 1000));
    }
    /**
     *  Upload process for a file.
     * @param file
     */
    uploadProcess(file, originalFile) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.steps = 2;
            file.state = 'uploading';
            file.progress = 10;
            file.loading = true;
            this.loadingMessage = 'Subiendo archivo';
            try {
                yield this.simulateProgress(file, 10, 30);
                const tokenData = yield this.generateToken();
                const token = tokenData.token;
                yield this.simulateProgress(file, 30, 50);
                let pk = null;
                if (file.fileType === 'pdf')
                    pk = yield this.missionsService.externalprocess(token, null, file.file);
                else
                    pk = yield this.missionsService.externalprocess(token, file.file);
                this.pk = pk.pk;
                file.pk = pk.pk;
                const data = pk;
                if (originalFile) {
                    yield this.missionsService.saveFile(data.upload.url, originalFile, data.upload.headers['Content-Type']);
                }
                else {
                    yield this.missionsService.saveFile(data.upload.url, this.originalFile, data.upload.headers['Content-Type']);
                }
                this.loadingMessage = 'Procesando IA';
                // if (this.ia_activities.length === 1) {
                if (this.selectedActivities.length === 1) {
                    this.loadingMessage = 'Comprobando reglas de la actividad';
                    yield this.simulateProgress(file, 50, 80);
                    yield this.missionsService.waitForResponse(token, pk.pk);
                    // const response: any = await this.missionsService.resultIaActivity(this.ia_activities[0].id, pk.pk);
                    const response = yield this.missionsService.resultIaActivity(this.selectedActivities[0].id, pk.pk);
                    yield this.simulateProgress(file, 80, 100);
                    file.state = 'success';
                    file.loading = false;
                    if (response.final_state === 'APPROVED') {
                        file.result_status = 'APPROVED';
                        file.reject_reasons = ["No hay reglas no cumplidas"];
                    }
                    else if (response.final_state === 'MANUAL_VALIDATION') {
                        file.result_status = 'MANUAL_VALIDATION';
                    }
                    else {
                        file.result_status = 'REJECTED';
                        file.reject_reasons = response.failed_rules;
                    }
                    // } else if (this.ia_activities.length > 1) {
                }
                else if (this.selectedActivities.length > 1) {
                    this.loadingMessage = 'Comprobando reglas de la actividad';
                    yield this.simulateProgress(file, 50, 80);
                    yield this.missionsService.waitForResponse(token, pk.pk);
                    // const response: any = await this.missionsService.resultIaActivity(this.ia_activities[0].id, pk.pk);
                    const response = yield this.missionsService.resultIaActivity(this.selectedActivities[0].id, pk.pk);
                    yield this.simulateProgress(file, 80, 100);
                    file.state = 'success';
                    file.loading = false;
                    if (response.final_state === 'APPROVED') {
                        file.result_status = 'APPROVED';
                        file.reject_reasons = ["No hay reglas no cumplidas"];
                    }
                    else if (response.final_state === 'MANUAL_VALIDATION') {
                        file.result_status = 'MANUAL_VALIDATION';
                    }
                    else {
                        file.result_status = 'REJECTED';
                        file.reject_reasons = response.failed_rules;
                    }
                }
            }
            catch (error) {
                console.error('Error uploading file:', error);
                file.state = 'error';
                file.loading = false;
                file.result_status = 'REJECTED';
                file.progress = 100;
            }
        });
    }
    /**
     * Simulate file upload progress.
     */
    simulateProgress(file, from, to, duration = 1000) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const steps = 10;
            const increment = (to - from) / steps;
            const delay = duration / steps;
            for (let i = 1; i <= steps; i++) {
                file.progress = Math.round(from + increment * i);
                yield this.sleep(delay);
            }
        });
    }
    /**
     * Pause for a specified amount of time.
     */
    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    /**
     * Get the status message based on the file state and result status.
     * @param item
     */
    getStatusMessage(item) {
        if (item.state === 'success') {
            if (item.result_status === 'APPROVED')
                return 'Aprobado';
            if (item.result_status === 'REJECTED')
                return 'No aprobado';
            if (item.result_status === 'MANUAL_VALIDATION')
                return 'Pendiente de validación';
        }
        if (item.state === 'error')
            return 'Error durante la carga';
        return '';
    }
    /**
     * Open the image in a new window
     * @param file
     */
    viewImage(file) {
        if (typeof file.file === 'string' && file.file.startsWith('data:image')) {
            const newWindow = window.open();
            if (newWindow) {
                newWindow.document.write(`<img src="${file.file}" style="max-width: 100%; height: auto;" />`);
            }
            else {
                alert('No se pudo abrir la vista previa. Desactiva el bloqueador de ventanas emergentes.');
            }
        }
        else if (file.file.startsWith('data:application/pdf')) {
            const base64String = file.file.split(',')[1];
            const byteCharacters = atob(base64String);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');
        }
        else {
            console.warn('Archivo no compatible para vista previa:', file);
        }
    }
    /**
     * Get the icon corresponding to the result status.
     * @param status
     */
    getResultIcon(status) {
        switch (status) {
            case 'APPROVED':
                return 'checkmark-circle';
            case 'REJECTED':
                return 'close-circle';
            case 'MANUAL_VALIDATION':
                return 'help-circle';
            default:
                return 'alert-circle';
        }
    }
    /**
     * Get the color corresponding to the result status.
     * @param status
     */
    getResultColor(status) {
        switch (status) {
            case 'APPROVED':
                return 'success';
            case 'REJECTED':
                return 'danger';
            case 'MANUAL_VALIDATION':
                return 'warning';
            default:
                return 'medium';
        }
    }
    /**
     * Get the hex color corresponding to the result status.
     * @param status
     */
    getResultColorHex(status) {
        switch (status) {
            case 'APPROVED':
                return '#2dd36f';
            case 'REJECTED':
                return '#eb445a';
            case 'MANUAL_VALIDATION':
                return '#ffc409';
            default:
                return '#666666';
        }
    }
    /**
     * Acepts an invoice and sends it to the server.
     * @param item
     */
    acceptInvoice(item) {
        item.state = 'sending';
        if ('additional_answers' in item) {
            for (let activity of this.selectedActivities) {
                if (((Array.isArray(activity.additional_questions) && activity.additional_questions.length > 0) ||
                    (typeof activity.additional_questions === 'object' && Object.keys(activity.additional_questions).length > 0))) {
                    const additionalAnswer = item.additional_answers
                        .flat(Infinity)
                        .find(answer => answer.activity_id === activity.id);
                    this.missionsService.saveResponse(activity.id, item.file, item.pk, item.result_status, additionalAnswer.answers_to_save)
                        .then(() => {
                        console.log('Factura enviada correctamente:', item);
                        item.state = 'send';
                        setTimeout(() => {
                            this.removeFromQueue(item);
                        }, 2000);
                    });
                }
                else {
                    this.missionsService.saveResponse(activity.id, item.file, item.pk, item.result_status)
                        .then(() => {
                        console.log('Factura enviada correctamente:', item);
                        item.state = 'send';
                        setTimeout(() => {
                            this.removeFromQueue(item);
                        }, 2000);
                    });
                }
            }
        }
        else {
            for (let activity of this.selectedActivities) {
                this.missionsService.saveResponse(activity.id, item.file, item.pk, item.result_status)
                    .then(() => {
                    console.log('Factura enviada correctamente:', item);
                    item.state = 'send';
                    setTimeout(() => {
                        this.removeFromQueue(item);
                    }, 2000);
                });
            }
        }
    }
    /**
     * Deletes an item from the upload queue.
     * @param item
     */
    removeFromQueue(item) {
        this.uploadFiles = this.uploadFiles.filter(i => i.id !== item.id);
        if (this.uploadFiles.length === 0) {
            this.steps = 1;
        }
    }
    /**
     * Send all files (APPROVED and MANUAL_VALIDATION).
     */
    sendAllFiles() {
        if (this.uploadFiles.length === 0)
            return;
        const validItems = this.uploadFiles.filter(item => item.result_status === 'APPROVED' || item.result_status === 'MANUAL_VALIDATION');
        if (validItems.length === 0) {
            this.toolsService.showErrorToast('No hay facturas para enviar.');
            return;
        }
        if (validItems.length > 0) {
            this.showQuestionsMultipleResults(validItems);
        }
    }
    /**
     * View the reject reasons.
     * @param item
     */
    viewRejectReasons(item) {
        this.reasons = item.reject_reasons;
        this.seeResults = true;
    }
    /**
     * Select an activity
     * @param activity
     */
    selectActivity(activity, event) {
        event.stopPropagation();
        this.selectedActivity = activity;
    }
    getReferralsInfo() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.missionsService.getReferralsInfo();
            const key = Object.keys(response).find(k => Array.isArray(response[k]));
            response[key].sort((a, b) => {
                return new Date(b.date_joined).getTime() - new Date(a.date_joined).getTime();
            });
            response[key].forEach(item => {
                item.date_joined = this.toolsService.formatDate(item.date_joined);
            });
            this.referrals_info = response;
        });
    }
    showResult(ia_results) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const listActivities = [];
            for (const result of ia_results) {
                if (this.playerData.level && this.playerData.level.name === 'Carpintero' &&
                    result.result.final_state === 'APPROVED' &&
                    result.activity.additional_questions != null &&
                    ((Array.isArray(result.activity.additional_questions) && result.activity.additional_questions.length > 0) ||
                        (typeof result.activity.additional_questions === 'object' && Object.keys(result.activity.additional_questions).length > 0))) {
                    listActivities.push(result.activity);
                }
            }
            if (listActivities.length === 0) {
                this.save();
            }
            else {
                const modal = yield this.modalController.create({
                    component: ModalAdditionalQuestionsPage,
                    cssClass: 'additional-questions-modal',
                    componentProps: {
                        listActivities: listActivities
                    }
                });
                yield modal.present();
                const { data } = yield modal.onWillDismiss();
                for (let answers of data) {
                    this.selectedActivities.forEach(activity => {
                        if (answers.activity_id === activity.id) {
                            activity.additional_answers = [answers];
                        }
                    });
                }
                this.save();
            }
        });
    }
    showQuestionsByResult(item = null) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const listActivities = [];
            for (let activity of this.selectedActivities) {
                if (item.result_status === 'APPROVED' &&
                    this.playerData.level && this.playerData.level.name === 'Carpintero' &&
                    activity.additional_questions != null &&
                    ((Array.isArray(activity.additional_questions) && activity.additional_questions.length > 0) ||
                        (typeof activity.additional_questions === 'object' && Object.keys(activity.additional_questions).length > 0))) {
                    listActivities.push(activity);
                }
            }
            if (listActivities.length === 0) {
                this.acceptInvoice(item);
            }
            else {
                const modal = yield this.modalController.create({
                    component: ModalAdditionalQuestionsPage,
                    cssClass: 'additional-questions-modal',
                    componentProps: {
                        listActivities: listActivities
                    }
                });
                yield modal.present();
                const { data } = yield modal.onWillDismiss();
                item.additional_answers = data;
                this.acceptInvoice(item);
            }
        });
    }
    showQuestionsMultipleResults(items = []) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const listActivities = [];
            for (let activity of this.selectedActivities) {
                const hasApprovedItem = items.some(item => item.result_status === 'APPROVED' &&
                    activity.additional_questions != null &&
                    this.playerData.level && this.playerData.level.name === 'Carpintero' &&
                    ((Array.isArray(activity.additional_questions) && activity.additional_questions.length > 0) ||
                        (typeof activity.additional_questions === 'object' && Object.keys(activity.additional_questions).length > 0)));
                if (hasApprovedItem) {
                    listActivities.push(activity);
                }
            }
            if (listActivities.length === 0) {
                items.forEach(item => {
                    this.acceptInvoice(item);
                });
            }
            else {
                const modal = yield this.modalController.create({
                    component: ModalAdditionalQuestionsPage,
                    cssClass: 'additional-questions-modal',
                    componentProps: {
                        listActivities: listActivities
                    }
                });
                yield modal.present();
                const { data } = yield modal.onWillDismiss();
                items.forEach(item => {
                    item.additional_answers = [data];
                    this.acceptInvoice(item);
                });
            }
        });
    }
    markActivityChecked(activity) {
        activity.checked = !activity.checked;
        if (activity.checked) {
            this.selectedActivities.push(activity);
        }
        else {
            this.selectedActivities = this.selectedActivities.filter(r => r.id != activity.id);
        }
        this.markAllActivities = this.selectedActivities.length === this.ia_activities.length;
    }
    toggleAllActivities() {
        const is_checked = !this.markAllActivities;
        for (let activity of this.ia_activities) {
            if (is_checked) {
                activity.checked = true;
                this.selectedActivities = [...this.ia_activities];
            }
            else {
                activity.checked = false;
                this.selectedActivities = [];
            }
        }
    }
    openModalResume() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.closeModal();
            const modal = yield this.modalController.create({
                component: ModalIaResultsResumePage,
                cssClass: 'ia-results-resume-modal',
                componentProps: {
                    ia_template: this.template
                }
            });
            yield modal.present();
        });
    }
}
